import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as defaultConfig } from "../../default/Kambi/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  bettingHistory: "/#/bethistory/",
  bettingRules: "/how-to-bet/betting-rules/general/",
  casinoUrl: "https://www.888casino.ro/",
  casinoNativeUrl: "https://casino-ro.onelink.me/wYn9/CrossSellSportToCasino",
  sportUrl: getSportUrl(),
  contactUs: "https://www.888.ro/contact-us/",
  help: "https://www.888.ro/contact-us/",
  home: "/",
  liveChat:
    "https://888-external-ro.custhelp.com/app/chat/chat_launch?chanel=888ro_ro_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-ro.custhelp.com/app/chat/chat_launch?chanel=888ro_ro_vip&ChRefId=3",
  liveNow: "/pariuri-live/",
  mySettings: "/#/settings",
  pokerUrl: "https://www.888poker.ro/",
  pokerUrlAuthenticated: "https://www.888poker.ro/openclient.htm",
  pokerNativeUrliOS:
    "https://poker-ro.onelink.me/BLo6/CrossSellSportToPokeriOS",
  pokerNativeUrlAndroid:
    "https://poker-ro.onelink.me/BLo6/CrossSellSportToPokerAndroid",
  privacyPolicy: "https://www.888.ro/security-and-privacy/privacy-policy/",
  promotions: "/sport-promotions/",
  responsibleGaming: "https://888.ro/responsible-gaming/",
  startingSoon: "/incepe-in-curand/",
  survey: clientPage,
  userAgreement: "https://www.888.ro/security-and-privacy/user-agreement/",
  pokerHistoryLink: "/app/istoric-poker/"
};

export const config = {
  ...defaultConfig,
  logo_VIP: "sport_logo_VIP"
};
